import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { Link, IndexLink, browserHistory } from 'react-router';

import Swipeable from 'react-swipeable';

import * as recipeActions from '../../actions/recipeActions';
import RecipeApi from '../../api/mockRecipeApi';
import RecipeCover from './RecipeCover';
import RecipeInfo from './RecipeInfo';
import RecipeExcerpt from './RecipeExcerpt';
import FileThisRecipe from './FileThisRecipe';

class RecipePage extends React.Component {
	//container component part 1:  set state and bind actions to component
	constructor(props, context) {
		super(props, context);

		this.state = {
			prevRecipeClass: "recipe-cover prev inactive",
			activeRecipeClass: "recipe-cover current active",
			nextRecipeClass: "recipe-cover next ready",
			showRecipeInfo: "inactive",
			showRecipeExcerpt: "inactive",
			showFileThisRecipe: "inactive"
		};

		this.toggleRecipeInfo = this.toggleRecipeInfo.bind(this);
		this.toggleRecipeExcerpt = this.toggleRecipeExcerpt.bind(this);
		this.toggleFileThisRecipe = this.toggleFileThisRecipe.bind(this);
	}

	componentDidMount() {
		//this.dispatchRecipe(this.props.recipeId); //set state here for pages loaded directly via URL
		//console.log("didmount");
	}

	componentWillReceiveProps(nextProps) {
		// console.log("receivedprops");
		// console.log(this.props.recipeId);
		// console.log(nextProps.recipeId);
		if (this.props.recipe !== nextProps.recipe) {
			//console.log("dispatched");
			this.setState({prevRecipeClass: "recipe-cover prev inactive"});
			this.setState({activeRecipeClass: "recipe-cover current active"});
			this.setState({nextRecipeClass: "recipe-cover next ready"});
			//this.dispatchRecipe(nextProps.recipeId); //set state here for pages pushed via URL
		}
	}

	//container component part 2:  child functions
	dispatchRecipe(recipe) {
		this.props.actions.loadRecipe(recipe);
	}

	toggleRecipeInfo() { //the "react way" is to add/remove class via state.  iow, objects look to the state to detarmine the class the should be (passed to component below)
		let css = (this.state.showRecipeInfo === "inactive") ? "active" : "inactive";
		this.setState({showRecipeInfo:css});
	}

	toggleRecipeExcerpt() {
		let css = (this.state.showRecipeExcerpt === "inactive") ? "active" : "inactive";
		this.setState({showRecipeExcerpt:css});
	}

	toggleFileThisRecipe() {
		let css = (this.state.showFileThisRecipe === "inactive") ? "active" : "inactive";
		let covercss = (this.state.activeRecipeClass === "recipe-cover editing") ? "recipe-cover active" : "recipe-cover editing";
		this.setState({showFileThisRecipe:css,activeRecipeClass:covercss});
	}

	toggleNextRecipe(nextLink) {
		if (nextLink) {
			this.setState({activeRecipeClass:"recipe-cover inactive"});
			this.setState({nextRecipeClass:"recipe-cover active"});
			setTimeout(() => {
				this.dispatchRecipe(nextLink);
			},250);
		}
	}

	togglePrevRecipe(prevLink) {
		this.setState({activeRecipeClass:"recipe-cover ready"});
		this.setState({prevRecipeClass:"recipe-cover active"});
		setTimeout(() => {
			this.dispatchRecipe(prevLink);
		},250);
	}

	//container component part 3:  display component (should not be straight HTML)
	render() {
		let recipe = this.props.recipe; 
		let recipes = this.props.recipes;
		let closeRecipes = this.props.closeRecipes;
		
		let showPrevLink = false;
		let showNextLink = false;
		let prevRecipe = {};
		let nextRecipe = {};
		let prevLink = '';
		let nextLink = '';
		let recipeCovers = '';

		if (recipe.length != 0 && recipes.length != 0) {
			/* Note: due to the way the "card" functionality works, the recipe component NEEDS a library's array of recipes in the active state, even if it's a library of just this recipe */

			let thisIndex = recipes.map(function(x) {return x.id; }).indexOf(recipe[0].id);
			prevRecipe = recipes[thisIndex - 1];
			nextRecipe = recipes[thisIndex + 1];
			if (prevRecipe != null) {
				prevLink = prevRecipe.id;
				showPrevLink = true;
			}
			if (nextRecipe != null) {
				nextLink = nextRecipe.id;
				showNextLink = true;
			}

			let zIndex = 100;
			let className = '';
			let prevClassName = this.state.prevRecipeClass;
			let activeClassName = this.state.activeRecipeClass;
			let nextClassName = this.state.nextRecipeClass;

			let recipeCovers = recipes.map(function(thisRecipe,i) {
				zIndex = zIndex - 1;
				//console.log(i);
				if (thisIndex > i+1) {
					className = "recipe-cover inactive";
				} else if (thisIndex == i+1) {
					className = prevClassName;
				} else if (thisIndex == i) {
					className = activeClassName;
				} else if (thisIndex == i-1) {
					className = nextClassName;
				} else {
					className = "recipe-cover ready";
				}
				return (	
				<RecipeCover
					key={thisRecipe.id}
					className={className}
					recipe={thisRecipe}
					zIndex={zIndex}
				/>);
			});

			let iconCloseRecipe = require('../../images/ui-close-grey.png');

			return (
				<div className="recipe-page">
					<div className="recipe-close" style={{backgroundImage: `url(${iconCloseRecipe})`}} onClick={closeRecipes}>Close</div>
					<div className="recipe-toggles">
						<div onClick={this.toggleRecipeInfo}>Swipe Down</div>&nbsp;
						<div onClick={this.toggleRecipeExcerpt}> - Click</div>&nbsp;
						<div onClick={this.toggleFileThisRecipe}> - Swipe Right</div>&nbsp;
						{showPrevLink && <div onClick={() => this.togglePrevRecipe(prevLink)}> - Prev Recipe</div>}&nbsp;
						{showNextLink && <div onClick={() => this.toggleNextRecipe(nextLink)}> - Next Recipe</div>}
					</div>
					<Swipeable
						onClick={this.toggleRecipeExcerpt}
						onSwipedDown={this.toggleRecipeInfo}
						onSwipedRight={this.toggleFileThisRecipe}
						onSwipedLeft={() => this.toggleNextRecipe(nextLink)}>
						{recipeCovers}
					</Swipeable>
					<Swipeable
						onSwipedUp={this.toggleRecipeInfo}>
						<RecipeInfo 
							recipe={recipe[0]}
							className={"recipe-info " + this.state.showRecipeInfo}
							onClick={this.toggleRecipeInfo}
						/>
					</Swipeable>
					<RecipeExcerpt
						recipe={recipe[0]}
						className={"recipe-excerpt " + this.state.showRecipeExcerpt}
						onClick={this.toggleRecipeExcerpt}
					/>
					<Swipeable
						onSwipedLeft={this.toggleFileThisRecipe}>
						<FileThisRecipe
							recipe={recipe[0]}
							className={"recipe-file " + this.state.showFileThisRecipe}
							onClick={this.toggleFileThisRecipe}
						/>
					</Swipeable>
				</div>
			);
		} else {
			return ( 
				<div className="recipe-page">
				</div>
			);
		}
		//temp fix: the arrow function "() => ..." above technically should not be used, but you can't pass arguments otherwise (executes on render). 
		//changed esLint rule jsx-no-bind to allowArrowFunctions: true					
	}
}

//container component part 4:  propTypes validation
RecipePage.propTypes = {
	recipe: PropTypes.array.isRequired,
	recipes: PropTypes.array.isRequired,
	actions: PropTypes.object.isRequired,
	closeRecipes: PropTypes.func.isRequired
};

//container component part 5:  connect and dispatch to Redux
function mapStateToProps(state, ownProps) {
	return {
		recipe: state.recipe,
		recipes: state.recipes
	};
}

function mapDispatchToProps(dispatch) {
	//debugger;
	return {
		actions: bindActionCreators(recipeActions, dispatch)
	};
}

export default connect(mapStateToProps,mapDispatchToProps)(RecipePage);


/** WEBPACK FOOTER **
 ** ./src/components/recipes/RecipeComponent.js
 **/